import React, { useState } from "react";
import styles from "./Sidebar.module.css";
import Logo from "../../Assets/PentLogo.png";
import { Home, FolderOpen, X } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";

const BANKS = [
  { id: "gtb", name: "GTBank" },
  { id: "uba", name: "UBA" },
  { id: "access", name: "Access Bank" },
  { id: "firstbank", name: "First Bank" },
  { id: "sterling", name: "Sterling Bank" },
  { id: "unionbank", name: "Union Bank" },
];

const SidebarLink = ({ to, end = true, children, onClick }) => (
  <NavLink
    to={to}
    end={end}
    onClick={onClick}
    className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
  >
    {children}
  </NavLink>
);

const Sidebar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBank, setSelectedBank] = useState("");
  const navigate = useNavigate();

  const handleWorkspaceClick = (e) => {
    e.preventDefault(); // Prevent immediate navigation
    setIsModalOpen(true);
  };

  const handleBankSelectSubmit = (e) => {
    e.preventDefault();
    if (!selectedBank) return;

    setIsModalOpen(false);
    // Navigates with search parameter (e.g., /Reconcilation/Workspace?bankId=gtb)
    navigate(`/Reconcilation/Workspace?bankId=${selectedBank}`);
    
    // If you prefer path variables (e.g., /Reconcilation/Workspace/gtb):
    // navigate(`/Reconcilation/Workspace/${selectedBank}`);
  };

  return (
    <>
      <aside className={styles.sidebar}>
        <div className={styles.brand}>
          <img src={Logo} alt="PENTSUITE" className={styles.logoImg} />
           <div className={styles.logoNameCont}>

              <h1>PENTSUITE</h1>
              <p>RECONCILIATION &<br />CONTROL SYSTEM</p>
            </div>
          </div>
          <div className={styles.divider}></div>
          <nav className={styles.nav}>
            <SidebarLink to="/dashboard" end>
              <span className={styles.icon}><Home size={16} /></span>
            <span className={styles.linkText}>Dashboard</span>
          </SidebarLink>

          <div className={styles.sectionTitle}>RECONCILIATION</div>

          <SidebarLink to="/Reconcilation">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Reconciliation Runs</span>
          </SidebarLink>

          {/* Handled Workspace Link */}
          <SidebarLink to="/Reconcilation/Workspace" onClick={handleWorkspaceClick}>
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Workspace</span>
          </SidebarLink>

          <SidebarLink to="/Reconcilation/Exceptions">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Exceptions</span>
          </SidebarLink>

          <SidebarLink to="/Reconcilation/MatchingRules">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Matching Rules</span>
          </SidebarLink>

          <div className={styles.sectionTitle}>TRANSACTIONS</div>

          <SidebarLink to="/bank-transactions/ledger">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Bank Transactions</span>
          </SidebarLink>

          <SidebarLink to="/bank-transactions/matched">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Ledger Transactions</span>
          </SidebarLink>

          <SidebarLink to="/bank-transactions/unmatched">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Matched</span>
          </SidebarLink>

          <SidebarLink to="/data/import-centre">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Unmatched</span>
          </SidebarLink>

          <div className={styles.sectionTitle}>DATA</div>

          <SidebarLink to="/bank-transactions">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Import Centre</span>
          </SidebarLink>

          <SidebarLink to="/data/bank-accounts">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Bank Accounts</span>
          </SidebarLink>

          <SidebarLink to="/data/data-sources">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Data Sources</span>
          </SidebarLink>

          <SidebarLink to="/Reconcilation/MatchingRules">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Matching Rules</span>
          </SidebarLink>

          <div className={styles.sectionTitle}>APPROVALS</div>

          <SidebarLink to="/approvals">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Approvals</span>
          </SidebarLink>

          <div className={styles.sectionTitle}>REPORTS</div>

          <SidebarLink to="/reports/reconciliation">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Reconciliation</span>
          </SidebarLink>

          <SidebarLink to="/reports/exceptions">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Exceptions</span>
          </SidebarLink>

          <SidebarLink to="/reports/ageing">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Ageing</span>
          </SidebarLink>

          <SidebarLink to="/reports/management">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Management</span>
          </SidebarLink>

          <div className={styles.sectionTitle}>AUDIT TRAIL</div>

          <SidebarLink to="/audit-trail">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Audit Trail</span>
          </SidebarLink>

          <div className={styles.sectionTitle}>ADMINISTRATION</div>
          <SidebarLink to="/administration/users">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Users</span>
          </SidebarLink>

          <SidebarLink to="/administration/roles-permissions">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Roles & Permissions</span>
          </SidebarLink>

          <SidebarLink to="/administration/organization">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Organization</span>
          </SidebarLink>

          <SidebarLink to="/administration/integrations">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Integrations</span>
          </SidebarLink>

          <SidebarLink to="/administration/notifications">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Notifications</span>
          </SidebarLink>

          <SidebarLink to="/administration/security">
            <span className={styles.icon}><FolderOpen size={16} /></span>
            <span className={styles.linkText}>Security</span>
          </SidebarLink>
        </nav>
      </aside>

      {/* Modal Popup */}
      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h3>Select Bank Account</h3>
              <button 
                className={styles.closeBtn} 
                onClick={() => setIsModalOpen(false)}
              >
                <X size={18} />
              </button>
            </div>
            <form onSubmit={handleBankSelectSubmit}>
              <div className={styles.formGroup}>
                <label htmlFor="bankSelect">Bank Account</label>
                <select
                  id="bankSelect"
                  value={selectedBank}
                  onChange={(e) => setSelectedBank(e.target.value)}
                  className={styles.selectInput}
                  required
                >
                  <option value="" disabled>-- Select a Bank --</option>
                  {BANKS.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className={styles.modalActions}>
                <button 
                  type="button" 
                  className={styles.cancelBtn} 
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className={styles.submitBtn} 
                  disabled={!selectedBank}
                >
                  Proceed to Workspace
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;